<template>

    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="type === 1 ? $i18n.t('product.text136') : type === 2 ? $i18n.t('product.text137') : $i18n.t('product.text138')"
        :visible.sync="visible"
        :width="(language === 'zh' ? 30 : 35) + '%'"
        @close="closeDialog"
        @open="openDialog">

        <el-form :model="form" size="small" :rules="rules" ref="ruleForm" class="firmware_form"
                 :label-width="formLabelWidth">

            <el-form-item :label="$i18n.t('product.text120')+'：'" prop="firmwareVersion">
                <el-input
                    v-model.trim="form.firmwareVersion"
                    :placeholder="$i18n.t('product.text139')">
                </el-input>
            </el-form-item>

            <el-form-item :label="$i18n.t('product.text140')+'：'" required :error="err">
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="$message.uploadImgUrl"
                    :data="{
                        bucket: 'firmware'
                    }"
                    :headers="{
                        accessToken: $token.getToken().accessToken,
                        refreshToken: $token.getToken().refreshToken,
                        language: $message.language
                    }"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-success="handleSuccess"
                    :limit="1"
                    accept=".img,.bin,.zip,.hex,.apk"
                    :file-list="fileList"
                    :on-exceed="handleExceed">
                    <el-button size="small" type="primary">{{$i18n.t('product.text141')}}</el-button>
                </el-upload>
            </el-form-item>

            <el-form-item :label="$i18n.t('product.text121')+'：'" prop="log">
                <el-input
                    type="textarea"
                    v-model="form.log"
                    :rows="4"
                    show-word-limit
                    maxlength="300"
                    :placeholder="$i18n.t('product.text142')">
                </el-input>
            </el-form-item>

        </el-form>


        <div class="demo-drawer__footer" style="text-align: right;margin-top: 50px">
            <el-button @click="closeDialog">{{$i18n.t('product.text63')}}</el-button>
            <el-button type="primary" :loading="loading" @click="submit()">{{$i18n.t('product.text65')}}</el-button>
        </div>

    </el-dialog>

</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
    name: "addFirmwareDialog",

    computed: {
        ...mapState('firmware', ['addFirmwareDialogVisible', 'firmwareDialogType'])
    },

    watch: {

        addFirmwareDialogVisible: {
            handler(newVal) {
                this.visible = newVal;
            }
        },

        firmwareDialogType: {
            handler(newVal) {
                this.type = newVal;
            }
        }

    },

    data() {

        return {

            visible: false,

            type: 1,

            loading: false,

            form: {
                firmwareVersion: "",
                log: ""
            },

            err: "",

            rules: {
                firmwareVersion: [
                    {required: true, message: this.$i18n.t('product.text143'), trigger: "blur"},
                    {pattern: /^(?=[\S\s]{1,20}$)[\S\s]*/, message: this.$i18n.t('product.text23')},
                    {pattern: /^[a-zA-Z0-9-.]*$/, message: this.$i18n.t('product.text144')},
                ],
                log: [
                    {required: true, message: this.$i18n.t('product.text145'), trigger: "blur"}
                ]
            },

            file: "",

            fileList: [],

            formLabelWidth: "100px",
            language: localStorage.getItem('language')

        }

    },

    methods: {

        ...mapActions('firmware', ['closeAddFirmwareDialog', 'addFirmware']),

        openDialog() {
            this.formLabelWidth = this.language === 'zh' ? '120px' : '160px'
        },

        closeDialog() {
            this.closeAddFirmwareDialog();
            this.$refs.ruleForm.resetFields();
            this.form = {
                firmwareVersion: "",
                log: ""
            };
            this.err = "";
            this.file = "";
            this.fileList = [];
        },

        handleSuccess(res, file) {
            if (res.success) {
                this.file = res.result.fileList[0].url;
            } else {
                this.$dialog.showMessage(res.resultMsg, this.$config.TOAST_ERROR);
                this.$refs.upload.clearFiles();
                console.log(res, file)
            }
        },

        handleRemove(file, fileList) {
            console.log(file, fileList);
        },

        handlePreview(file) {
            console.log(file);
        },

        handleExceed(files, fileList) {
            // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },

        beforeRemove(file, fileList) {
            return this.$confirm(`${this.$i18n.t('product.text146')} ${file.name}？`).then(() => {
                this.file = ""
            });
        },

        submit() {
            console.log(this.file)
            let isStop = false;
            if (!this.file) {
                this.err = this.$i18n.t('product.text147');
                isStop = true;
            }
            if (this.type === 3) {
                //测试
                this.$dialog.showMessage(this.$i18n.t('product.text148'), this.$config.TOAST_SUCCESS);
                this.$emit('getMsg');
                this.closeDialog();
                return
            }
            this.$refs.ruleForm.validate((valid) => {
                if (!isStop && valid) {
                    this.err = "";
                    this.loading = true;
                    this.addFirmware({
                        name: this.form.firmwareVersion,
                        productCode: this.$route.query.id,
                        remark: this.form.log,
                        url: this.file,
                        type: this.type
                    }).then(res => {
                        this.$dialog.showMessage(this.$i18n.t('product.text148'), this.$config.TOAST_SUCCESS);
                        this.$emit('getMsg');
                        this.closeDialog();
                    }, err => {
                        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        }

    }

}
</script>

<style scoped>

.firmware_form {
    margin-top: 20px;
}

/deep/ .el-dialog {
    text-align: left !important;
}

/deep/ .el-dialog--center .el-dialog__footer {
    text-align: right !important;
}

/deep/ .el-dialog__body {
    padding-top: 0;
}

/deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #E9E9E9;
    padding: 13px;
}
</style>
